import type { NextPage } from 'next'
import { ThankYouOrder } from '@/client/modules/ThankYouOrder'
import { ThankYouOrderProps } from '@/client/modules/ThankYouOrder/types'
import { getCMSContent } from '@/client/utils'

const ThankYouOrderPage: NextPage<ThankYouOrderProps> = (data) => <ThankYouOrder {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'THANK_YOU_ORDER')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default ThankYouOrderPage
